module.exports = __webpack_public_path__ + "static/media/impresora.f6ed8dd7.svg";